import { render, staticRenderFns } from "./PanelAddPerson.vue?vue&type=template&id=507fd751&scoped=true&"
import script from "./PanelAddPerson.vue?vue&type=script&lang=js&"
export * from "./PanelAddPerson.vue?vue&type=script&lang=js&"
import style0 from "./PanelAddPerson.vue?vue&type=style&index=0&id=507fd751&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507fd751",
  null
  
)

export default component.exports